import React from 'react';
import {useNavigate } from "react-router-dom";
import { withParams } from "../../utils/withParams";
// import Image from "../Rander/Cyber-island-screen.gif";
// import Ransomewarescroll from "../Rander/banners/Ransomeware.gif";
import Image1 from "../Rander/ransomeware-boat.png";

const Toolkit = () => {

const navigate = useNavigate();

const handleNavigation = () => {
  navigate(withParams("/cyberisland/ransomewareQuestion"));
}
  return (
  <div className="container-fluid p-0 phishing-module">
  <img src={Image1} alt="Logo" className="set-boat-ransomeware"/>
  <div className="d-flex vh-100">
    <div className="splash">
      {/* <img src={Image} alt="Logo" /> */}
      <button className="phishing-gamestart-btn" onClick={() => handleNavigation()}>
      Next
      </button>
      <div className='toolkit-scroll'>
      <img src="https://dqib2w4u3w0ne.cloudfront.net/Rander/banners/Ransomeware.gif" alt="Logo" />
      </div>
    </div>
  </div>
</div>
  )
}
export default Toolkit
